import { Fragment } from "react";
import { PLATFORM_STEPS, type PlatformStep } from "./status";

const DONE = "#059669";
const ACTIVE = "#2563eb";
const PENDING = "#cbd5e1";
const MUTED = "#94a3b8";

function normalize(label: string): PlatformStep {
  if ((PLATFORM_STEPS as readonly string[]).includes(label)) return label as PlatformStep;
  const l = label.toLowerCase();
  if (l.includes("transit") || l.includes("progress")) return "In Transit";
  if (l.includes("dock") || l.includes("arrived") || l.includes("open") || l.includes("check")) return "At Dock";
  if (l.includes("return") || l.includes("storing")) return "Returning";
  return "Available";
}

export default function PlatformStepper({
  status,
  steps = PLATFORM_STEPS,
  activeIndex,
}: {
  status: string;
  steps?: readonly string[];
  activeIndex?: number;
}) {
  const idx = activeIndex ?? PLATFORM_STEPS.indexOf(normalize(status));

  return (
    <div style={{ width: "100%", paddingBottom: 4 }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        {steps.map((step, i) => {
          const color = i < idx ? DONE : i === idx ? ACTIVE : PENDING;
          return (
            <Fragment key={step}>
              <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {i === idx && (
                  <span
                    style={{
                      position: "absolute",
                      display: "inline-flex",
                      height: 20,
                      width: 20,
                      borderRadius: 9999,
                      backgroundColor: ACTIVE,
                      opacity: 0.25,
                    }}
                  />
                )}
                <span
                  style={{
                    position: "relative",
                    height: 12,
                    width: 12,
                    borderRadius: 9999,
                    backgroundColor: color,
                    transition: "background-color 400ms",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    top: "100%",
                    marginTop: 6,
                    whiteSpace: "nowrap",
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontSize: 11,
                    fontWeight: i === idx ? 600 : 400,
                    color: i < idx ? DONE : i === idx ? ACTIVE : MUTED,
                  }}
                >
                  {step}
                </span>
              </div>
              {i < steps.length - 1 && (
                <div style={{ flex: 1, height: 2, backgroundColor: i < idx ? DONE : PENDING, transition: "background-color 400ms" }} />
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
